import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PlanService {
  constructor(private http: HttpClient) {}
  url = environment.url;

  getPlan(type) {
    return this.http.get(`${this.url}/plan/all/${type}`);
  }

  getIndexPublicity() {
    return this.http.get(`${this.url}/publicity/indexType`);
  }

  getFilePublicity(nameFile) {
    return this.http.get(`${this.url}/file/publicity/${nameFile}`);
  }

  postPublicity(body) {
    return this.http.post(`${this.url}/publicity/store`, body);
  }

  aprovePublicity(body){
    return this.http.post(`${this.url}/admin/publicity/approved`, body);
  }

  setCode(parent){
    return new Promise((resolve, reject) => {
      this.http.post(`${this.url}/superUser/updateCode`, { parent })
      .subscribe(res => {
        resolve(res);
      }, err => {
        reject(err);
      })
    })
  }
}
